import { Progress } from '../../progress';
import { formatPsTokens } from '../helpers/ps-tokens-display';

interface TokenUsageBarProps {
  label: string;
  used: number;
  total: number;
  subtitle?: string | null;
  limitMessage?: string | null;
}

export function TokenUsageBar({
  label,
  used,
  total,
  subtitle,
  limitMessage,
}: TokenUsageBarProps) {
  const percentage = total > 0 ? Math.min((used / total) * 100, 100) : 0;
  const isExhausted = total > 0 && used >= total;

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-prompt-safecomvulcan">{label}</p>
      <Progress value={percentage} />
      <div className="flex items-center justify-between">
        <p className="text-xs text-prompt-safecomabbey">
          {total > 0 ? (
            <>
              {formatPsTokens(used)} / {formatPsTokens(total)} PS tokens
            </>
          ) : (
            'No PS tokens purchased'
          )}
        </p>
        {subtitle && (
          <p className="text-xs text-prompt-safecomabbey">{subtitle}</p>
        )}
      </div>
      {isExhausted && limitMessage && (
        <p className="text-xs font-medium text-red-600">{limitMessage}</p>
      )}
    </div>
  );
}
